/** Maps Checkout Display Fields row keys to company.settings keys (snake_case). */
export const CHECKOUT_DISPLAY_EDITABLE_SETTING_KEYS_BY_FIELD = {
  ir_comment: "inventory_request_comments_name",
  ir_configurable_field_1: "inventory_request_configurable_field_1_name",
  ir_configurable_field_2: "inventory_request_configurable_field_2_name",
  ir_configurable_field_3: "inventory_request_configurable_field_3_name",
  ir_configurable_field_4: "inventory_request_configurable_field_4_name",
  ir_configurable_field_5: "inventory_request_configurable_field_5_name",
};

export const CHECKOUT_DISPLAY_LABEL_SETTING_KEYS = Object.values(
  CHECKOUT_DISPLAY_EDITABLE_SETTING_KEYS_BY_FIELD
);
